import {
  CodeModuleWorkerUrls,
  CODE_MODULE_DEPLOY_ERROR_MESSAGE_MAX_LENGTH,
} from './types';

/**
 * Trims a Cloudflare rejection message to what we are willing to persist.
 */
export function truncateDeployErrorMessage(
  message: string | null | undefined
): string | null {
  if (!message) {
    return null;
  }
  return message.slice(0, CODE_MODULE_DEPLOY_ERROR_MESSAGE_MAX_LENGTH);
}

/**
 * Normalizes the componentUrlMap to a CodeModuleWorkerUrls object.
 */
export function normalizeCodeModuleWorkerUrlMap(
  componentUrlMap: Record<string, string> | undefined | null
): Record<string, CodeModuleWorkerUrls> | null {
  if (!componentUrlMap) {
    return null;
  }
  return Object.entries(componentUrlMap).reduce<
    Record<string, CodeModuleWorkerUrls>
  >((acc, [moduleId, url]) => {
    acc[moduleId] = {
      components: url,
    };
    return acc;
  }, {});
}

/**
 * Whether a bundle is served from the developer's own machine. Only a library
 * that was never published carries a loopback bundle URL, so its modules exist
 * nowhere but on that machine.
 */
export function isLoopbackBundleUrl(url: string): boolean {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return false;
  }
  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    return false;
  }
  return ['localhost', '127.0.0.1', '[::1]'].includes(
    parsed.hostname.toLowerCase()
  );
}
